import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { Observer } from "mobx-react";

import LinearProgress from "../../components/LinearProgress";
import Footer from "./Footer";
import MCQOption from "./MCQOption";
import { getMobileOperatingSystem, hRatio } from "../../constants/utils";
import QuestionareStore from "../../stores/QuestionareStore";
import styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import { Background3 } from "../../components/Background";
import DataScreen1 from "./DataScreen1";
import DataScreen2 from "./DataScreen2";
import { SlideIn } from "../../../new_onboarding/transitions/transitions";
import { AnimatePresence } from "framer-motion";
import heart from "../../../assets/adhd/heart.webp";
import IC_Component from "../../components/IC_Component";
import axios from "axios";

const Questionare = () => {
  const navigate = useNavigate();
  const isiOS = getMobileOperatingSystem() === "iOS";

  useEffect(() => {
    QuestionareStore.setNavigation(navigate);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        type: 'ic',
        content_id: 3449,
      };

      const headers = {
        'no-encryption': 'True',
      };

      try{
        const response = await axios.get('https://api.evolveinc.in/api/v3/content/details', {
          params,
          headers
        });

        const ic_link = response.data.data?.content_details?.ic_link
        if(!ic_link) return;

        // const corsProxy = 'https://cors-anywhere.herokuapp.com/';
        const proxiedUrl = ic_link;

        const content_data = await axios.get(proxiedUrl)
        const jsonData = content_data
        const questions_array = jsonData.data.ic
        // console.log("Final ic json: ",questions_array)
        QuestionareStore.setQuestions(questions_array)
      }
      catch(error){
        console.log("API fetch error: ", error)
      }
    };

    fetchData();

  }, []);


  return (
    <Observer>
      {() => {
        const currentStepIndex = QuestionareStore.currentStepIndex;
        const questions = QuestionareStore.QUESTIONS;

        if(!questions || questions.length===0){
          return(
              <Background3>
                <div className={styles.Container}>
                  <div className={styles.BarContainer}>
                    <LinearProgress progress={0} />
                  </div>
                  <div className={styles.LoadingText}>Loading questions...</div>
                </div>
              </Background3>
          );
        }

        // console.log(QuestionareStore.QUESTIONS[currentStepIndex].isMultiSelect)
        const progress =
          (currentStepIndex / (QuestionareStore.QUESTIONS.length)) * 100;
        return (
          <Background3>
            <AnimatePresence>
              <div className={styles.Container}>
                  <>
                    <div className={styles.BarContainer}>
                      <LinearProgress progress={progress} />
                    </div>
                      <IC_Component 
                        key={QuestionareStore.currentStepIndex}
                        item={QuestionareStore.QUESTIONS[currentStepIndex]}
                      />

                      <Footer isQuestionScreen={true}/>
                    
                  </>
                {/* )} */}
              </div>
            </AnimatePresence>
          </Background3>
        );
      }}
    </Observer>
  );
};

export default Questionare;
